import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";

// Captures beforeinstallprompt and offers a branded "Download App" install button.
// Renders nothing when the app is already installed or the browser can't prompt.
export default function InstallAppButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
      setInstalled(true);
      return;
    }
    const onBeforeInstall = (e) => {
      e.preventDefault(); // suppress the default mini-infobar
      setDeferredPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferredPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !deferredPrompt) return null;

  const install = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <button
      onClick={install}
      data-testid="pwa-install-btn"
      className="flex items-center gap-1.5 px-3.5 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm bg-[#E6F2FA] hover:bg-[#D2E9F5] border border-[#B3E0F2] text-[#3D7E9E] rounded-full font-bold transition-all duration-200 hover:-translate-y-0.5 shadow-sm"
    >
      <Download className="w-3.5 h-3.5" /> Download App
    </button>
  );
}
